import * as React from "react";
import { AuditList } from "../common/AuditList";

const RestaurantAudit = () => <AuditList resource="restaurants" />;

export default RestaurantAudit;
